import { type FilterLegacy } from '@verantos-dev/types-cohorts';

export const getNextFilterForInputFieldValueUpdate = (
  filters: FilterLegacy[],
  filterId: string,
  inputFieldId: string,
  value: string
) => {
  return filters.map((filter) => {
    if (filter.id === filterId) {
      // input fields to the right of the changed input field should be cleared to avoid throwing an error
      const currentInputFieldIndex = filter.inputFields.findIndex(
        (inputField) => inputField.id === inputFieldId
      );
      const inputFields =
        currentInputFieldIndex !== -1
          ? [
              ...filter.inputFields.slice(0, currentInputFieldIndex),
              { ...filter.inputFields[currentInputFieldIndex], value, dirty: true },
            ]
          : [];
      return {
        ...filter,
        inputFields,
      };
    }
    return filter;
  });
};
